// PLEASE DO NOT FORMAT THIS FILE
// PLEASE DO NOT FORMAT THIS FILE
import PropTypes from 'prop-types'
import React from 'react'
import PromotionValidationDelete from '../src/components/promotion_validations/PromotionValidationDelete'
import AdminNew from './components/admins/AdminNew'
import AuthorizedAdminEmailDomainCreate from './components/admins/AuthorizedAdminEmailDomainCreate'
import AuthorizedAdminEmailDomainDelete from './components/admins/AuthorizedAdminEmailDomainDelete'
import AgencyCreateEdit from './components/agencies/AgencyCreateEdit.js'
import AgencyDelete from './components/agencies/AgencyDelete.js'
import AgencyShow from './components/agencies/AgencyShow'
import GridExport from './components/general/GridExport.js'
import OrgRoleCreate from './components/roles/OrgRoleCreate'

const PortalTagsGrid = React.lazy(() => import('../src/components/portals/tags/PortalTagsGrid'))
const PortalTagSetsGrid = React.lazy(() => import('./components/portals/tags/PortalTagSetsGrid.js'))
const PortalTagsProductsGrid = React.lazy(() => import('../src/components/portals/tags/PortalTagsProductsGrid'))
const PortalProductGrid = React.lazy(() => import('../src/components/portals/PortalProductGrid'))
const PurchaseOrderItemsGrid = React.lazy(() => import('../src/components/purchase_order/PurchaseOrderItemsGrid'))
const ClientPortalsGrid = React.lazy(() => import('../src/components/portals/ClientPortalsGrid'))
const ClientsGrid = React.lazy(() => import('../src/components/clients/ClientsGrid'))
const CustomersGrid = React.lazy(() => import('../src/components/users/CustomersGrid'))
const GoodReceiptItemList = React.lazy(() => import('../src/components/purchase_order/GoodReceiptItemList'))
const ImportCustomersGrid = React.lazy(() => import('../src/components/portals/ImportCustomersGrid'))
const LocationGroupsList = React.lazy(() => import('../src/components/portals/LocationGroupsList'))
const OrdersGrid = React.lazy(() => import('../src/components/orders/OrdersGrid'))
const OrdersReviewGrid = React.lazy(() => import('../src/components/orders/review/OrdersReviewGrid'))
const PageList = React.lazy(() => import('../src/components/portals/PageList'))
const PortalShowEditPOC = React.lazy(() => import('../src/components/portals/PortalShowEditPOC'))
const ProductsGrid = React.lazy(() => import('../src/components/products/ProductsGrid'))
const ShipperHqBoxesGrid = React.lazy(() => import('../src/components/products/ShipperHqBoxesGrid'))
const ShipperHqGroupsGrid = React.lazy(() => import('../src/components/products/ShipperHqGroupsGrid'))
const ShipperHqOriginsGrid = React.lazy(() => import('../src/components/products/ShipperHqOriginsGrid'))
const ShipperHqPackingRulesGrid = React.lazy(() => import('../src/components/products/ShipperHqPackingRulesGrid'))
const ClientCreate = React.lazy(() => import('../src/components/clients/ClientCreate'))
const ClientShow = React.lazy(() => import('../src/components/clients/ClientShow'))
const ClientDelete = React.lazy(() => import('../src/components/clients/ClientDelete'))
const ClientImage = React.lazy(() => import('../src/components/clients/ClientImage'))
const PortalList = React.lazy(() => import('../src/components/portals/PortalList'))
// const PortalNew = React.lazy(() => import('../src/components/portals/PortalNew'))
const PortalEdit = React.lazy(() => import('../src/components/portals/PortalEdit'))
const PortalDelete = React.lazy(() => import('../src/components/portals/PortalDelete'))
const PageShow = React.lazy(() => import('../src/components/pages/PageShow'))
const PageNew = React.lazy(() => import('../src/components/pages/PageNew'))
const PageEdit = React.lazy(() => import('../src/components/pages/PageEdit'))
const PageDelete = React.lazy(() => import('../src/components/pages/PageDelete'))
const GenericTemplateEdit = React.lazy(() => import('../src/components/templates/GenericTemplateEdit'))
const AboutTemplateEdit = React.lazy(() => import('../src/components/templates/AboutTemplateEdit'))
const HomeTemplateEdit = React.lazy(() => import('../src/components/templates/HomeTemplateEdit'))
const DomainNew = React.lazy(() => import('../src/components/domains/DomainNew'))
const DomainDelete = React.lazy(() => import('../src/components/domains/DomainDelete'))
const DomainEdit = React.lazy(() => import('../src/components/domains/DomainEdit'))
const ClientImageDelete = React.lazy(() => import('./components/clients/ClientImageDelete'))
const ProductEdit = React.lazy(() => import('../src/components/products/ProductEdit'))
const ProductWarehouseList = React.lazy(() => import('../src/components/products/ProductWarehouseList'))
const LocationProductRemove = React.lazy(() => import('../src/components/locations/LocationProductRemove'))
const ProductArtwork = React.lazy(() => import('../src/components/products/ProductArtwork'))
const AuthorizedAdminEmailDomainsShow = React.lazy(() => import('./components/admins/AuthorizedAdminEmailDomainsShow'))

const IPWhitelistManagement = React.lazy(() => import('./components/admins/IPWhitelistManagement'))
const IPBlacklistManagement = React.lazy(() => import('./components/admins/IPBlacklistManagement'))
const BundleCreate = React.lazy(() => import('./components/bundles/BundleCreate'))
const BundleEdit = React.lazy(() => import('./components/bundles/BundleEdit'))
const UserList = React.lazy(() => import('./components/users/UserList'))
const UserShow = React.lazy(() => import('./components/users/UserShow'))
const UserDelete = React.lazy(() => import('./components/users/UserDelete'))
const UserNew = React.lazy(() => import('./components/users/UserNew'))
const UserEdit = React.lazy(() => import('./components/users/UserEdit'))
const InitiatePasswordResetForAllUsers = React.lazy(() => import('./components/users/InitiatePasswordResetForAllUsers'))

const LocationShow = React.lazy(() => import('./views/Portals/StoreViews/single'))

const StoreViewNew = React.lazy(() => import('../src/views/Portals/StoreViews/create'))
const LocationEdit = React.lazy(() => import('../src/components/locations/LocationEdit'))
const LocationDelete = React.lazy(() => import('../src/components/locations/LocationDelete'))
const LocationCategoryList = React.lazy(() => import('./components/categories/LocationCategoryList'))
const ProductConfigWizardForm = React.lazy(() => import('./components/products/ConfigWizard/ProductConfigWizardForm'))
const CategoryDelete = React.lazy(() => import('./components/categories/CategoryDelete'))
const OrderErrorsGrid = React.lazy(() => import('../src/components/orders/OrderErrorsGrid'))

// Product Wizard
const ProductForm = React.lazy(() => import('./components/products/ProductWizard/ProductForm'))

// Product Details
const ProductShow = React.lazy(() => import('./components/products/ProductDetails/ProductShow.js'))

// Configurable Variant
const VariantNew = React.lazy(() => import('./components/product_configuration/VariantNew'))
const VariantShowEdit = React.lazy(() => import('./components/product_configuration/VariantShowEdit'))
const ConfigurableVariantList = React.lazy(() => import('./components/product_configuration/ConfigurableVariantList'))
const VariantDelete = React.lazy(() => import('./components/product_configuration/VariantDelete'))

// Configurable Options
const OptionShowEdit = React.lazy(() => import('./components/configurable_options/OptionShowEdit'))
const OptionNew = React.lazy(() => import('./components/configurable_options/OptionNew'))
const OptionDelete = React.lazy(() => import('./components/configurable_options/OptionDelete'))

const Page404 = React.lazy(() => import('../src/components/error_pages/Page404'))
const Page500 = React.lazy(() => import('../src/components/error_pages/Page500'))
const NewCustomerGroup = React.lazy(() => import('./components/customer_groups/NewCustomerGroup'))
const NewCustomerGroupRule = React.lazy(() => import('./components/customer_group_rules/NewCustomerGroupRule'))
const CustomerGroupRuleEdit = React.lazy(() => import('./components/customer_group_rules/CustomerGroupRuleEdit'))
const CustomerGroupShow = React.lazy(() => import('./components/customer_groups/CustomerGroupShow'))
const CustomerGroupRuleShow = React.lazy(() => import('./components/customer_group_rules/CustomerGroupRuleShow'))
const RuleHiddenProductRemove = React.lazy(() => import('./components/customer_group_rules/RuleHiddenProductRemove'))
const RuleHiddenCategoryRemove = React.lazy(() => import('./components/customer_group_rules/RuleHiddenCategoryRemove'))
const WarehouseList = React.lazy(() => import('./components/warehouses/WarehouseList'))
const WarehouseNew = React.lazy(() => import('./components/warehouses/WarehouseNew'))
const WarehouseEdit = React.lazy(() => import('./components/warehouses/WarehouseEdit'))
const WarehouseShow = React.lazy(() => import('./components/warehouses/WarehouseShow'))
const WarehouseDelete = React.lazy(() => import('./components/warehouses/WarehouseDelete'))
const InventoryLog = React.lazy(() => import('./components/warehouses/InventoryLog'))
const PageContentEdit = React.lazy(() => import('./components/pages/PageContentEdit'))
const PageContentBlockDelete = React.lazy(() => import('./components/pages/PageContentBlockDelete'))
const OrderApprovalList = React.lazy(() => import('./components/orders/order_approval/OrderApprovalList'))
// const OrderList                 = React.lazy(() => import("./components/orders/OrderList"));
const OrderLogsList = React.lazy(() => import('./components/orders/OrderLogsList'))
const OrderSplitPage = React.lazy(() => import('./components/orders/OrderSplitPage'))
const CardTransactionsList = React.lazy(() => import('./components/card_payments/CardTransactionsList'))
const ImageDelete = React.lazy(() => import('./components/images/ImageDelete'))
const ProductSkuShow = React.lazy(() => import('./components/product_skus/ProductSkuShow'))
const NewBaseOverride = React.lazy(() => import('./components/product_skus/NewBaseOverride'))
const EditBaseOverride = React.lazy(() => import('./components/product_skus/EditBaseOverride'))
const ArtworkCreate = React.lazy(() => import('./components/artworks/ArtworkCreate'))
const ArtworkList = React.lazy(() => import('./components/artworks/ArtworkList'))
const ArtworkShow = React.lazy(() => import('./components/artworks/ArtworkShow'))
const ArtworkDelete = React.lazy(() => import('./components/artworks/ArtworkDelete'))
const FulfilmentView = React.lazy(() => import('./components/orders/FulfillmentView'))
const FulfilmentViewNew = React.lazy(() => import('./components/orders/FulfilmentViewNew'))

const ManageCarriersView = React.lazy(() => import('./components/orders/manage_carriers/ManageCarriersView'))

// Tools
const ShippingRateLogsList = React.lazy(() => import('./components/tools/ShippingRateLogsList'))
const ShippingRateLogDetail = React.lazy(() => import('./components/tools/ShippingRateLogDetail'))

// Promotions
// PLEASE DO NOT FORMAT THIS FILE
const PromotionList = React.lazy(() => import('./components/promotions/PromotionList'))
const PromotionNew = React.lazy(() => import('./components/promotions/PromotionNew'))
const PromotionShow = React.lazy(() => import('./components/promotions/PromotionShow'))
const PromotionDelete = React.lazy(() => import('../src/components/promotions/PromotionDelete'))
const PromotionRuleDelete = React.lazy(() => import('../src/components/promotion_rules/PromotionRuleDelete'))
const PromotionRuleNew = React.lazy(() => import('./components/promotion_rules/PromotionRuleNew'))
const PromotionRuleShow = React.lazy(() => import('./components/promotion_rules/PromotionRuleShow'))
const PromotionValidationNew = React.lazy(() => import('./components/promotion_validations/PromotionValidationNew'))
const PromotionValidationShow = React.lazy(() => import('./components/promotion_validations/PromotionValidationShow'))
const PromotionCodeDelete = React.lazy(() => import('../src/components/promotion_codes/PromotionCodeDelete'))
const PromotionCodeEdit = React.lazy(() => import('../src/components/promotion_codes/PromotionCodeEdit'))
const PromotionCodeNew = React.lazy(() => import('./components/promotion_codes/PromotionCodeNew'))
const SettingList = React.lazy(() => import('./components/settings/SettingList'))
const SettingEdit = React.lazy(() => import('../src/components/settings/SettingEdit'))

// Purchase orders
// PLEASE DO NOT FORMAT THIS FILE
const PurchaseOrderNew = React.lazy(() => import('./components/purchase_order/PurchaseOrderNew'))
const PurchaseOrderEdit = React.lazy(() => import('./components/purchase_order/PurchaseOrderEdit'))
const PurchaseOrderShow = React.lazy(() => import('./components/purchase_order/PurchaseOrderShow'))
const GoodsReceiptNew = React.lazy(() => import('./components/good_receipt/GoodReceiptNew'))
const PurchaseOrderList = React.lazy(() => import('./components/purchase_order/PurchaseOrderList'))
const PurchaseOrderItemsList = React.lazy(() => import('./components/purchase_order/PurchaseOrderItemsList'))
const PurchaseOrderDuplicate = React.lazy(() => import('./components/purchase_order/PurchaseOrderDuplicate'))
const GoodsReceiptLog = React.lazy(() => import('./components/purchase_order/GoodsReceiptLog'))

// Vendors
// PLEASE DO NOT FORMAT THIS FILE
const VendorNew = React.lazy(() => import('./components/vendors/VendorNew'))
const VendorEdit = React.lazy(() => import('./components/vendors/VendorEdit'))
const VendorShow = React.lazy(() => import('./components/vendors/VendorShow'))
const VendorDelete = React.lazy(() => import('./components/vendors/VendorDelete'))

// TemplateForms
// PLEASE DO NOT FORMAT THIS FILE
const TemplateFormNew = React.lazy(() => import('./components/template_form/TemplateFormNew'))
const TemplateEdit = React.lazy(() => import('./components/template_form/TemplateEdit'))
const TemplateFormShow = React.lazy(() => import('./components/template_form/TemplateFormShow'))
const TemplateFormDelete = React.lazy(() => import('./components/template_form/TemplateFormDelete'))

// Roles
// PLEASE DO NOT FORMAT THIS FILE
const RoleList = React.lazy(() => import('./components/roles/RoleList'))
const RoleNew = React.lazy(() => import('./components/roles/RoleNew'))
const RoleShow = React.lazy(() => import('./components/roles/RoleShow'))
const RoleEdit = React.lazy(() => import('./components/roles/RoleEdit'))
const RoleDelete = React.lazy(() => import('./components/roles/RoleDelete'))

// Artwork
// PLEASE DO NOT FORMAT THIS FILE
const ArtworkEdit = React.lazy(() => import('./components/artworks/ArtworkEdit'))
const ArtworkFamilyCreate = React.lazy(() => import('./components/artwork_families/ArtworkFamilyCreate'))
const AsyncErrorLogsGrid = React.lazy(() => import('./components/async_error_logs/AsyncErrorLogsGrid.js'))
const VendorsGrid = React.lazy(() => import('../src/components/vendors/VendorsGrid'))
const ProductTemplatesGrid = React.lazy(() => import('../src/components/product_templates/ProductTemplatesGrid'))
const OrgRolesGrid = React.lazy(() => import('../src/components/roles/OrgRolesGrid'))
const OrganizationAdminsGrid = React.lazy(() => import('../src/components/admins/OrganizationAdminsGrid'))
const AgenciesGrid = React.lazy(() => import('../src/components/agencies/AgenciesGrid'))
const ArtworkFieldList = React.lazy(() => import('./components/artworks/ArtworkFieldList'))

// Admins
// PLEASE DO NOT FORMAT THIS FILE
const AdminsGrid = React.lazy(() => import('../src/components/admins/AdminsGrid'))
const AdminShow = React.lazy(() => import('./components/admins/AdminShow'))
const AdminDelete = React.lazy(() => import('./components/admins/AdminDelete'))
const AdminEdit = React.lazy(() => import('./components/admins/AdminEdit'))

// Dropship Batches
// PLEASE DO NOT FORMAT THIS FILE
const DropshipBatchShow = React.lazy(() => import('./components/dropship_batches/DropshipBatchShow'))
const Dashboard = React.lazy(() => import('./views/Dashboard'))

// Passwords
// PLEASE DO NOT FORMAT THIS FILE
const UpdatePasswordForm = React.lazy(() => import('./containers/DefaultLayout/components/navbar/UpdatePasswordForm'))

const SsoFeaturebaseRedirect = React.lazy(() => import('./components/external_sso/SsoFeaturebaseRedirect'))
const SsoMetabaseRedirect = React.lazy(() => import('./components/external_sso/SsoMetabaseRedirect'))

//INTEGRATIONS
const IntegrationsGrid = React.lazy(() => import('./components/integrations/IntegrationsGrid'))
const IntegrationLoader = React.lazy(() => import('./components/integrations/IntegrationLoader'))

const PortalsView = React.lazy(() => import('./views/Portals/all'))
const PortalsNew = React.lazy(() => import('./views/Portals/create'))
// const PortalsEdit = React.lazy(() => import('./views/Portals/edit'))
const PortalView = React.lazy(() => import('./components/portals/PortalShow.js'))

export const DefaultRoute = '/dashboard'

/**
 * @typedef {Object} Route
 * @property {string} path
 * @property {string} name
 * @property {React.Component} component
 * @property {string[] | null} granted
 * @property {boolean | null} exact
 * @property {string | null} layout
 * @property {string | null} breadcrumb
 * @property {boolean | null} orgLevel
 */

export const routePropTypes = PropTypes.shape({
  path: PropTypes.string.isRequired, // Required string for the route path
  name: PropTypes.string.isRequired, // Required string for the route name
  component: PropTypes.elementType.isRequired, // React component type
  granted: PropTypes.arrayOf(PropTypes.string), // Array of strings or null
  exact: PropTypes.bool, // Boolean or null
  layout: PropTypes.string, // String or null
  breadcrumb: PropTypes.string, // String or null
  orgLevel: PropTypes.bool // Boolean or null
})

/** @type {Route[]} */
export const Routes = [
  {
    path: '/',
    name: 'Home',
    component: Dashboard,
    granted: null,
    exact: true,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    granted: null,
    exact: null,
    layout: null,
    breadcrumb: 'Dashboard',
    orgLevel: null
  },
  {
    path: '/update_password/organization_admin',
    name: 'Update Password Form',
    component: UpdatePasswordForm,
    granted: null,
    exact: true,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/update_password',
    name: 'Update Password Form',
    component: UpdatePasswordForm,
    granted: null,
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/sso/external/featurebase',
    name: 'Sign In',
    component: SsoFeaturebaseRedirect,
    granted: null,
    exact: true,
    layout: 'BlankLayout',
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/sso/external/metabase',
    name: 'Sign In',
    component: SsoMetabaseRedirect,
    granted: null,
    exact: true,
    layout: 'BlankLayout',
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/clients/create',
    name: 'Create Client',
    component: ClientCreate,
    granted: ['CLIENT.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/clients/:id/delete',
    name: 'Delete Client',
    component: ClientDelete,
    granted: ['CLIENT.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/clients/:id',
    name: 'Client',
    component: ClientShow,
    granted: ['CLIENT.read', 'PORTAL.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/clients',
    name: 'Clients',
    component: ClientsGrid,
    granted: ['CLIENT.read', 'PORTAL.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/client_portals',
    name: 'Portals',
    component: ClientPortalsGrid,
    granted: ['PORTAL.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/client_image/:id',
    name: 'Client Image',
    component: ClientImage,
    granted: ['CLIENT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  // {
  //   path: '/portals/create/:client_id',
  //   name: 'New Portal',
  //   component: PortalNew,
  //   granted: ['PORTAL.create'],
  //   exact: null,
  //   layout: null,
  //   breadcrumb: null,
  //   orgLevel: null
  // },
  {
    path: '/portals/:id/edit',
    name: 'Portal Edit',
    component: PortalEdit,
    granted: ['PORTAL.read', 'LOCATION.read', 'CMS.read', 'COOP_FUNDING.read', 'CUST_GROUPS.read', 'COOP_CREDIT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },

  {
    path: '/show_portal/:portalId/new_promotion',
    name: 'Create Promotion',
    component: PromotionNew,
    granted: null,
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_portal/:portalId/edit_location_groups',
    name: 'LocationGroupsList',
    component: LocationGroupsList,
    granted: ['LOCATIONS.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/portals/:id/delete',
    name: 'Delete Portal',
    component: PortalDelete,
    granted: ['PORTAL.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_page/:id',
    name: 'Page',
    component: PageShow,
    granted: ['PORTAL.read', 'CMS.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_page/:id',
    name: 'Edit Page',
    component: PageEdit,
    granted: ['PORTAL.read', 'CMS.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/new_page/:portal_id',
    name: 'New Page',
    component: PageNew,
    granted: ['PORTAL.update', 'CMS.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_page/:id',
    name: 'Delete Page',
    component: PageDelete,
    granted: ['PORTAL.update', 'CMS.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_page_content/:id',
    name: 'Edit Page Content',
    component: PageContentEdit,
    granted: ['PORTAL.update', 'CMS.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_generic_template/:id',
    name: 'Edit Generic Template',
    component: GenericTemplateEdit,
    granted: ['PORTAL.update', 'CMS.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_about_template/:id',
    name: 'AboutTemplateEdit',
    component: AboutTemplateEdit,
    granted: ['PORTAL.update', 'CMS.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_home_template/:id',
    name: 'HomeTemplateEdit',
    component: HomeTemplateEdit,
    granted: ['PORTAL.update', 'CMS.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/new_domain/:portal_id',
    name: 'DomainNew',
    component: DomainNew,
    granted: ['PORTAL.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_domain/:id',
    name: 'DomainDelete',
    component: DomainDelete,
    granted: ['PORTAL.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_domain/:id',
    name: 'DomainEdit',
    component: DomainEdit,
    granted: ['PORTAL.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_client_image/:id',
    name: 'ClientImageDelete',
    component: ClientImageDelete,
    granted: ['CLIENT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/configurable_variant/:configurable_variant_id/new_option',
    name: 'OptionNew',
    component: OptionNew,
    granted: ['PRODUCT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/configurable_variant/:configurable_variant_id/configurable_option/:id',
    name: 'OptionShowEdit',
    component: OptionShowEdit,
    granted: ['PRODUCT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/configurable_variant/:configurable_variant_id/delete_option/:id',
    name: 'OptionDelete',
    component: OptionDelete,
    granted: ['PRODUCT.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/configurable_variant/:id',
    name: 'VariantShowEdit',
    component: VariantShowEdit,
    granted: ['PRODUCT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/:id/configure',
    name: 'Product Config Wizard',
    component: ProductConfigWizardForm,
    granted: ['PRODUCT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/configurable_variants',
    name: 'ConfigurableVariantList',
    component: ConfigurableVariantList,
    granted: ['PRODUCTS.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/new_variant',
    name: 'VariantNew',
    component: VariantNew,
    granted: ['PRODUCT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/delete_variant/:id',
    name: 'VariantDelete',
    component: VariantDelete,
    granted: ['PRODUCT.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/shq_boxes',
    name: 'ShipperHQ Boxes',
    component: ShipperHqBoxesGrid,
    granted: ['PRODUCT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/shq_origins',
    name: 'ShipperHqOrigins',
    component: ShipperHqOriginsGrid,
    granted: ['PRODUCT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/shq_packing_rules',
    name: 'ShipperHQ Packing Rules',
    component: ShipperHqPackingRulesGrid,
    granted: ['PRODUCT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/shq_shipping_groups',
    name: 'ShipperHQ Groups',
    component: ShipperHqGroupsGrid,
    granted: ['PRODUCT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/create',
    name: 'Create Product',
    granted: 'PRODUCT_WIZARD.create',
    component: ProductForm,
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/:id/edit',
    name: 'Edit Product',
    component: ProductEdit,
    granted: ['PRODUCT_WIZARD.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products',
    name: 'Products',
    component: ProductsGrid,
    granted: ['PRODUCT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/products/:id',
    name: 'Product',
    granted: ['PRODUCT.read', 'PRODUCT_WIZARD.read'],
    component: ProductShow,
    exact: null,
    layout: null,
    breadcrumb: 'Product',
    orgLevel: null
  },
  {
    path: '/product_warehouses/:id',
    name: 'Product Warehouses',
    component: ProductWarehouseList,
    granted: ['PRODUCT.read', 'WAREHOUSE.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/product_artwork/:id',
    name: 'Product Artwork',
    component: ProductArtwork,
    granted: ['ARTWORK.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/product/:id/edit',
    name: 'Edit Product',
    component: ProductEdit,
    granted: ['PRODUCT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/remove_location_product/:location_id/:product_id',
    name: 'Remove Store View Product',
    component: LocationProductRemove,
    granted: ['LOCATION.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/new_location/:id/:location_group_id',
    name: 'StoreViewNew',
    component: StoreViewNew,
    granted: ['LOCATION.create'],
    breadcrumb: 'New Store View',
    exact: null,
    layout: null,
    orgLevel: null
  },
  {
    path: '/locations/:id/edit',
    name: 'LocationEdit',
    component: LocationEdit,
    granted: ['LOCATION.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/locations/:id/delete',
    name: 'LocationDelete',
    component: LocationDelete,
    granted: ['LOCATION.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/locations/:id',
    name: 'LocationShow',
    component: LocationShow,
    granted: ['LOCATION.read'],
    exact: null,
    layout: null,
    breadcrumb: 'Store View',
    orgLevel: null
  },
  {
    path: '/ip_blacklist_management',
    name: 'IPBlacklistManagement',
    component: IPBlacklistManagement,
    granted: ['SUPER_ADMIN'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/ip_whitelist_management',
    name: 'IPWhitelistManagement',
    component: IPWhitelistManagement,
    granted: ['SUPER_ADMIN'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/admins/create',
    name: 'Create Admin',
    component: AdminNew,
    granted: ['ADMIN.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/admins/:id/edit',
    name: 'Edit Admin',
    component: AdminEdit,
    granted: ['ADMIN.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/admins/:id/delete',
    name: 'Delete Admin',
    component: AdminDelete,
    granted: ['ADMIN.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/admins/:id',
    name: 'Admin',
    component: AdminShow,
    granted: ['ADMIN.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/organization_admins/create',
    name: 'Create Organization Admin',
    component: AdminNew,
    granted: ['ORGANIZATION_ADMIN.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/organization_admins/:id/delete',
    name: 'Delete Admin',
    component: AdminDelete,
    granted: ['ORGANIZATION_ADMIN.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/organization_admins/:id/edit',
    name: 'Edit Admin',
    component: AdminEdit,
    granted: ['ORGANIZATION_ADMIN.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/organization_admins/:id',
    name: 'Admin',
    component: AdminShow,
    granted: ['ORGANIZATION_ADMIN.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/admins',
    name: 'Admins',
    component: AdminsGrid,
    granted: ['ADMIN.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_admin/:id',
    name: 'Admin Show',
    component: AdminShow,
    granted: ['ADMIN.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_admin/:id',
    name: 'Delete Admin',
    component: AdminDelete,
    granted: ['ADMIN.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_admin/:id',
    name: 'Edit Admin',
    component: AdminEdit,
    granted: ['ADMIN.update'],
    exact: null,
    layout: null,
    breadcrumb: 'Admin Edit',
    orgLevel: null
  },
  {
    path: '/new_admin_email_domain',
    name: 'AuthorizedAdminEmailDomainCreate',
    component: AuthorizedAdminEmailDomainCreate,
    granted: ['SUPER_ADMIN'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/authorized_admin_email_domains',
    name: 'AuthorizedAdminEmailDomainsShow',
    component: AuthorizedAdminEmailDomainsShow,
    granted: ['SUPER_ADMIN'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_admin_email_domain/:id/:name',
    name: 'AuthorizedAdminEmailDomainDelete',
    component: AuthorizedAdminEmailDomainDelete,
    granted: ['SUPER_ADMIN'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/roles',
    name: 'Roles',
    component: RoleList,
    granted: ['ADMIN.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/new_role',
    name: 'New Role',
    component: RoleNew,
    granted: ['ADMIN.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_role/:id',
    name: 'Role',
    component: RoleShow,
    granted: ['ADMIN.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_role/:id',
    name: 'Edit Role',
    component: RoleEdit,
    granted: ['ADMIN.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_role/:id',
    name: 'Delete Role',
    component: RoleDelete,
    granted: ['ADMIN.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_category/:id',
    name: 'CategoryDelete',
    component: CategoryDelete,
    granted: ['PORTAL.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_category_location/:id',
    name: 'LocationCategoryList',
    component: LocationCategoryList,
    granted: ['PORTAL.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/new_bundle',
    name: 'BundleCreate',
    component: BundleCreate,
    granted: ['PRODUCT.create', 'BUNDLE_WIZARD.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_bundle/:id',
    name: 'Edit Bundle',
    component: BundleEdit,
    granted: ['PRODUCT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/purchase_orders/:id/duplicate',
    name: 'Duplicate Purchase Order',
    component: PurchaseOrderDuplicate,
    granted: ['PURCHASE_ORDER.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/purchase_orders',
    name: 'PurchaseOrderList',
    component: PurchaseOrderList,
    granted: ['PURCHASE_ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/purchase_orders/items',
    name: 'PurchaseOrderItemsList',
    component: PurchaseOrderItemsList,
    granted: ['PURCHASE_ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/not_found_page',
    name: 'Page404',
    component: Page404,
    granted: null,
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/internal_server_error_page',
    name: 'NotFoundPage',
    component: Page500,
    granted: null,
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/customers/:id/edit',
    name: 'Edit Customer',
    component: UserEdit,
    granted: ['USER.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/customers/:id/delete',
    name: 'Delete Customer',
    component: UserDelete,
    granted: ['USER.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/customers/create',
    name: 'Create Customer',
    component: UserNew,
    granted: ['USER.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/customers/:id',
    name: 'Customer',
    component: UserShow,
    granted: ['USER.read', 'USER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/customers',
    name: 'Customers',
    component: CustomersGrid,
    granted: ['USER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/customers_old',
    name: 'Users',
    component: UserList,
    granted: ['USER.read', 'GIFT_CARD.read', 'PORTAL_CREDIT.read', 'COOP_CREDIT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_customer/:id',
    name: 'Customer Show',
    component: UserShow,
    granted: ['USER.read', 'GIFT_CARD.read', 'PORTAL_CREDIT.read', 'COOP_CREDIT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_customer/:id',
    name: 'Customer Delete',
    component: UserDelete,
    granted: ['USER.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_customer/:id',
    name: 'Customer Edit',
    component: UserEdit,
    granted: ['USER.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/new_customer',
    name: 'Customer New',
    component: UserNew,
    granted: ['USER.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/initiate_password_reset_for_all_users',
    name: 'InitiatePasswordResetForAllUsers',
    component: InitiatePasswordResetForAllUsers,
    granted: ['USER.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/portal/:id/customer_groups/create',
    name: 'NewCustomerGroup',
    component: NewCustomerGroup,
    granted: ['PORTAL.update', 'CUST_GROUPS.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/portal/:id/customer_group_rules/create',
    name: 'NewCustomerGroupRule',
    component: NewCustomerGroupRule,
    granted: ['PORTAL.update', 'CUST_GROUPS.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_customer_group_rule/:id',
    name: 'CustomerGroupRuleEdit',
    component: CustomerGroupRuleEdit,
    granted: ['PORTAL.update', 'CUST_GROUPS.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/customer_groups/:id',
    name: 'CustomerGroupShow',
    component: CustomerGroupShow,
    granted: ['PORTAL.read', 'CUST_GROUPS.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/customer_group_rules/:id',
    name: 'CustomerGroupRuleShow',
    component: CustomerGroupRuleShow,
    granted: ['PORTAL.read', 'CUST_GROUPS.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/remove_rule_hidden_product/:rule_id/:product_id',
    name: 'Remove Rule Hidden Product',
    component: RuleHiddenProductRemove,
    granted: null,
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/remove_rule_hidden_category/:rule_id/:category_id',
    name: 'Remove Rule Hidden Category',
    component: RuleHiddenCategoryRemove,
    granted: null,
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/warehouses',
    name: 'Warehouses',
    component: WarehouseList,
    granted: ['WAREHOUSE.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/create_warehouse',
    name: 'Create Warehouse',
    component: WarehouseNew,
    granted: ['WAREHOUSE.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_warehouse/:id',
    name: 'Edit Warehouse',
    component: WarehouseEdit,
    granted: ['WAREHOUSE.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_warehouse/:id',
    name: 'Show Warehouse',
    component: WarehouseShow,
    granted: ['WAREHOUSE.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_warehouse/:id',
    name: 'Delete Warehouse',
    component: WarehouseDelete,
    granted: ['WAREHOUSE.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_goods_receipt/:id',
    name: 'Goods Receipt Notes Log',
    component: GoodsReceiptLog,
    granted: ['PURCHASE_ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/inventory_log/:id',
    name: 'InventoryLog',
    component: InventoryLog,
    granted: ['WAREHOUSE.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_content_block/:id',
    name: 'Delete Content Block',
    component: PageContentBlockDelete,
    granted: ['PORTAL.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/card_transactions_list',
    name: 'Card Transactions',
    component: CardTransactionsList,
    granted: null,
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/orders/split/:id',
    name: 'Order Split',
    component: OrderSplitPage,
    granted: ['ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/tools/order_logs',
    name: 'Orders Logs',
    component: OrderLogsList,
    granted: ['ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/tools/shipping_rate_logs/:logId',
    name: 'Shipping Rate Log Detail',
    component: ShippingRateLogDetail,
    granted: ['ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/tools/shipping_rate_logs',
    name: 'Shipping Rate Logs',
    component: ShippingRateLogsList,
    granted: ['ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/orders/review',
    name: 'Orders Review',
    component: OrdersReviewGrid,
    granted: ['ORDER.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/orders/errors',
    name: 'Order Errors',
    component: OrderErrorsGrid,
    granted: ['ORGANIZATION_ADMIN.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/orders',
    name: 'Orders',
    component: OrdersGrid,
    granted: ['ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/order_approval',
    name: 'Order Approval',
    component: OrderApprovalList,
    granted: ['ORDER.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_image/:id',
    name: 'Image Delete',
    component: ImageDelete,
    granted: null,
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_product_sku/:id',
    name: 'Product SKu Show',
    component: ProductSkuShow,
    granted: null,
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/new_base_sku_override/:id',
    name: 'SKU Override Create',
    component: NewBaseOverride,
    granted: ['PRODUCT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_base_sku_override/:id',
    name: 'SKU Override Update',
    component: EditBaseOverride,
    granted: ['PRODUCT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/create_artwork',
    name: 'ArtworkCreate',
    component: ArtworkCreate,
    granted: ['PRODUCT.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/artworks',
    name: 'Artworks',
    component: ArtworkList,
    granted: ['PRODUCT.read'],
    exact: true,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_artwork/:id',
    name: 'Artwork Show',
    component: ArtworkShow,
    granted: ['PRODUCT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/artworks/artwork_fields',
    name: 'Artwork Fields',
    component: ArtworkFieldList,
    granted: ['ARTWORK.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_artwork/:id',
    name: 'Artwork Edit',
    component: ArtworkEdit,
    granted: ['PRODUCT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_artwork/:id',
    name: 'Artwork Delete',
    component: ArtworkDelete,
    granted: ['PRODUCT.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/create_artwork_family',
    name: 'ArtworkFamilyCreate',
    component: ArtworkFamilyCreate,
    granted: ['PRODUCT.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/fulfillment',
    name: 'Fulfilment View',
    component: FulfilmentViewNew,
    granted: ['ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/carriers',
    name: 'Carriers',
    component: ManageCarriersView,
    granted: ['ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/dropship',
    name: 'Dropshipping',
    component: FulfilmentView,
    granted: ['ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_promotion/:id',
    name: 'Promotion Show',
    component: PromotionShow,
    granted: ['COUPON.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/new_promotion',
    name: 'Create Promotion',
    component: PromotionNew,
    granted: ['COUPON.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_promotion/:id',
    name: 'PromotionDelete',
    component: PromotionDelete,
    granted: ['COUPON.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/promotions',
    name: 'Promotion',
    component: PromotionList,
    granted: ['COUPON.read'],
    exact: true,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/promotion_validation_new/:promotion_id',
    name: 'Validation New',
    component: PromotionValidationNew,
    granted: ['COUPON.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_promotion_validation/:id',
    name: 'Validation Show',
    component: PromotionValidationShow,
    granted: ['COUPON.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_promotion_validation/:id',
    name: 'PromotionValidationDelete',
    component: PromotionValidationDelete,
    granted: ['COUPON.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/promotion_rule_new/:promotion_id',
    name: 'Rule New',
    component: PromotionRuleNew,
    granted: ['COUPON.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_promotion_rule/:id',
    name: 'Rule Show',
    component: PromotionRuleShow,
    granted: ['COUPON.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/delete_promotion_rule/:id',
    name: 'PromotionRuleDelete',
    component: PromotionRuleDelete,
    granted: ['COUPON.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/purchase_order_new',
    name: 'Purchase Order New',
    component: PurchaseOrderNew,
    granted: ['PURCHASE_ORDER.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/purchase_order_edit/:id',
    name: 'Purchase Order Edit',
    component: PurchaseOrderEdit,
    granted: ['PURCHASE_ORDER.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/purchase_orders',
    name: 'Purchase Order',
    component: PurchaseOrderList,
    granted: ['PURCHASE_ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/show_purchase_order/:id',
    name: 'Purchase Order Show',
    component: PurchaseOrderShow,
    granted: ['PURCHASE_ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/purchase_orders/:id/generate_purchase_order',
    name: 'Purchase Order PDF',
    component: PurchaseOrderShow,
    granted: ['PURCHASE_ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/promotion_codes/create/:promotion_id',
    name: 'Promotion New Code',
    component: PromotionCodeNew,
    granted: ['COUPON.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/promotion_codes/:id/delete',
    name: 'Promotion Delete Code',
    component: PromotionCodeDelete,
    granted: ['COUPON.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/promotion_codes/:id/edit',
    name: 'Promotion Edit Code',
    component: PromotionCodeEdit,
    granted: ['COUPON.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/goods_receipt_new/:purchase_order_id',
    name: 'Goods Receipt New',
    component: GoodsReceiptNew,
    granted: ['PURCHASE_ORDER.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/settings',
    name: 'SettingList',
    component: SettingList,
    granted: ['SUPER_ADMIN'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/edit_setting/:id',
    name: 'SettingEdit',
    component: SettingEdit,
    granted: ['SUPER_ADMIN'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/templates/create',
    name: 'Template Form New',
    component: TemplateFormNew,
    granted: ['PRODUCT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/templates/:id/delete',
    name: 'Template Form Delete',
    component: TemplateFormDelete,
    granted: ['PRODUCT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/templates/:id/edit',
    name: 'Template Form Edit',
    component: TemplateEdit,
    granted: ['PRODUCT.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/templates/:id',
    name: 'Template Form Show',
    component: TemplateFormShow,
    granted: ['PRODUCT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/templates',
    name: 'Product Templates',
    component: ProductTemplatesGrid,
    granted: ['PRODUCT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/vendors/create',
    name: 'Vendor New',
    component: VendorNew,
    granted: ['VENDORS.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/vendors/:id/edit',
    name: 'Vendor Update',
    component: VendorEdit,
    granted: ['VENDORS.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/vendors/:id/delete',
    name: 'Vendor Delete',
    component: VendorDelete,
    granted: ['VENDORS.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/vendors/:id',
    name: 'Vendor Show',
    component: VendorShow,
    granted: ['VENDORS.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/vendors',
    name: 'Vendors',
    component: VendorsGrid,
    granted: ['VENDORS.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/dropship_batch/:id',
    name: 'Dropship Batch Show',
    component: DropshipBatchShow,
    granted: ['DROPSHIP_BATCH.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/portal_show_edit_poc/:id',
    name: 'PortalShowEditPOC',
    component: PortalShowEditPOC,
    granted: ['ADMIN.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },

  // Portals Settings

  {
    path: '/portals/:id/import_users',
    name: 'Import Customers',
    component: ImportCustomersGrid,
    granted: ['PORTAL.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/portals_old',
    name: 'Portals_old',
    component: PortalList,
    granted: [
      'PORTAL.read',
      'LOCATION.read',
      'CMS.read',
      'COOP_FUNDING.read',
      'CUST_GROUPS.read',
      'COOP_CREDIT.read',
      'CREDIT_REDEMPTION.read'
    ],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/portal/pages',
    name: 'Pages',
    component: PageList,
    granted: ['PORTAL.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/good_receipts/item',
    name: 'GoodReceiptItemList',
    component: GoodReceiptItemList,
    granted: ['PURCHASE_ORDER.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/agencies/create',
    name: 'New Agency',
    component: AgencyCreateEdit,
    granted: ['AGENCY.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/agencies/:id/edit',
    name: 'Edit Agency',
    component: AgencyCreateEdit,
    granted: ['AGENCY.update'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/agencies/:id/delete',
    name: 'Edit Agency',
    component: AgencyDelete,
    granted: ['AGENCY.delete'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/agencies/:id',
    name: 'View Agency',
    component: AgencyShow,
    granted: ['AGENCY.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/po_items',
    name: 'Purchase Order Items',
    component: PurchaseOrderItemsGrid,
    granted: ['PURCHASE_ORDER.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/portal_product_grid_temp',
    name: 'PortalProductGrid',
    component: PortalProductGrid,
    granted: ['PORTAL.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },

  {
    path: '/grid_exports/:id/download',
    name: 'Grid Export',
    component: GridExport,
    granted: ['ADMIN.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/agencies',
    name: 'Agencies',
    component: AgenciesGrid,
    granted: ['AGENCY.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/organization_admins',
    name: 'Organization Admins',
    component: OrganizationAdminsGrid,
    granted: ['ORGANIZATION_ADMIN.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/org_roles/create',
    name: 'Create Organization Role',
    component: OrgRoleCreate,
    granted: ['ORG_ROLE.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/org_roles',
    name: 'Organization Roles',
    component: OrgRolesGrid,
    granted: ['ORG_ROLE.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: true
  },
  {
    path: '/client_portals',
    name: 'Portals',
    component: ClientPortalsGrid,
    granted: ['PORTAL.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/client_portals',
    name: 'Portals',
    granted: 'PORTAL.read',
    component: ClientPortalsGrid
  },
  {
    path: '/async_error_logs',
    name: 'General Erros',
    component: AsyncErrorLogsGrid,
    granted: ['SUPER_ADMIN.read'],
    exact: null,
    layout: null,
    breadcrumb: 'General Erros',
    orgLevel: true
  },
  {
    path: '/portaltagsproducts',
    name: 'Products for Tag',
    granted: 'PORTAL.read',
    component: PortalTagsProductsGrid
  },
  {
    path: '/portaltags',
    name: 'Portal Tag Sets',
    granted: 'PORTAL.read',
    component: PortalTagSetsGrid
  },
  {
    path: '/portal/tag_sets',
    name: 'EditTag Sets',
    granted: 'PORTAL.read',
    component: PortalTagsGrid
  },
  {
    path: '/integrations',
    name: 'Integrations',
    component: IntegrationsGrid,
    granted: ['PORTAL.read'],
    exact: null,
    layout: null,
    breadcrumb: 'Integrations',
    orgLevel: null
  },
  {
    path: '/integrations/:integrationId',
    name: 'Integration Edit',
    component: IntegrationLoader,
    granted: ['PORTAL.read'],
    exact: null,
    layout: null,
    breadcrumb: 'Edit Integration',
    orgLevel: null
  },
  {
    path: '/portals',
    name: 'Portals',
    component: PortalsView,
    granted: ['PORTAL.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/portals/:id',
    name: 'Portal Show',
    component: PortalView,
    granted: ['PORTAL.read', 'LOCATION.read', 'CMS.read', 'COOP_FUNDING.read', 'CUST_GROUPS.read', 'COOP_CREDIT.read'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  },
  {
    path: '/portals/create/:client_id',
    name: 'New Portal',
    component: PortalsNew,
    granted: ['PORTAL.create'],
    exact: null,
    layout: null,
    breadcrumb: null,
    orgLevel: null
  }
  // {
  //   path: '/portals2/:id',
  //   name: 'Portal Show 2',
  //   component: PortalShow2,
  //   granted: ['PORTAL.read', 'LOCATION.read', 'CMS.read', 'COOP_FUNDING.read', 'CUST_GROUPS.read', 'COOP_CREDIT.read'],
  //   exact: null,
  //   layout: null,
  //   breadcrumb: 'Portal Show 2',
  //   orgLevel: null
  // },
  // {
  //   path: '/portals2/',
  //   name: 'Portal Grid 2',
  //   component: PortalsGrid2,
  //   granted: ['PORTAL.read', 'LOCATION.read', 'CMS.read', 'COOP_FUNDING.read', 'CUST_GROUPS.read', 'COOP_CREDIT.read'],
  //   exact: null,
  //   layout: null,
  //   breadcrumb: 'Portal Grid 2',
  //   orgLevel: null
  // },
  // {
  //   path: '/ccdp_options',
  //   name: 'Data Points Options',
  //   granted: 'PORTAL.read',
  //   component: CcDataPointsOptionsGrid
  // }
]

// PLEASE DO NOT END THE Routes ARRAY WITH A COMMA
